export default __webpack_public_path__ + "static/media/HighCriticaly.52f7a574.svg";